export default __webpack_public_path__ + "static/media/scheduler.df4b06fa.png";